/**
 * @generated SignedSource<<c8fce5ae7d77fe76c0a5aea12edc0025>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type libraryImportTaskQueriesRestartMutation$variables = {
  taskID: number;
};
export type libraryImportTaskQueriesRestartMutation$data = {
  readonly restartLibraryImportTask: {
    readonly errorCount: number;
    readonly importedImages: number;
    readonly progressPercent: number;
    readonly state: number;
    readonly stateName: string;
    readonly taskID: number;
    readonly totalImages: number | null;
  };
};
export type libraryImportTaskQueriesRestartMutation = {
  response: libraryImportTaskQueriesRestartMutation$data;
  variables: libraryImportTaskQueriesRestartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskID",
        "variableName": "taskID"
      }
    ],
    "concreteType": "LibraryImportTask",
    "kind": "LinkedField",
    "name": "restartLibraryImportTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "progressPercent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "importedImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "libraryImportTaskQueriesRestartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "libraryImportTaskQueriesRestartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7377dd93613acab6ed04c9a374f97896",
    "id": null,
    "metadata": {},
    "name": "libraryImportTaskQueriesRestartMutation",
    "operationKind": "mutation",
    "text": "mutation libraryImportTaskQueriesRestartMutation(\n  $taskID: Long!\n) {\n  restartLibraryImportTask(taskID: $taskID) {\n    taskID\n    state\n    stateName\n    progressPercent\n    importedImages\n    totalImages\n    errorCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f731ae9b44b14ab86d867a366172497";

export default node;
